"use client"; // Error components must be Client Components

import SomethingWentWrong from "@components/table/SomethingWentWrong";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <SomethingWentWrong
      heightFull={true}
      message={`${process.env.NEXT_PUBLIC_ENV === "QA" ||
          process.env.NEXT_PUBLIC_ENV === "DEV"
          ? `ERROR- ${error.message}`
          : "Something went wrong!"
        }`}
      onClick={reset}
    />
  );
}
